import { render, staticRenderFns } from "./usedStudy.vue?vue&type=template&id=5af71b79"
import script from "./usedStudy.vue?vue&type=script&lang=js"
export * from "./usedStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports